module.exports = __webpack_public_path__ + "img/chevron-left.f8d8f793.svg";